import { isInternetExplorer } from 'src/utilities/isInternetExplorer';
import { MediaTypes, saveFile } from 'src/utilities/saveFile';

export function saveZipFile(
  data: string | ArrayBuffer,
  filename: string
): void {
  const mime = isInternetExplorer()
    ? MediaTypes.APPLICATION_ZIP_IE
    : MediaTypes.APPLICATION_ZIP;
  saveFile(data, filename, mime);
}
